import React from 'react';

export function ProjectProgressActivities({ activities }: { activities: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Hoạt động liên quan</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Xem tất cả</button>
      </div>

      <div className="space-y-4">
        {activities.map((act, idx) => (
          <div key={idx} className="flex gap-3">
             <div className="w-8 h-8 rounded-md bg-slate-50 flex items-center justify-center shrink-0">
                <i className="ri-history-line text-slate-400" />
             </div>
             <div className="space-y-0.5 min-w-0">
                <p className="text-xs text-slate-600 leading-tight">
                  <span className="font-normal text-slate-900">{act.user}</span> {act.action}
                  <span className="font-normal text-emerald-600"> {act.target}</span>
                </p>
                <p className="text-xs font-normal text-slate-400">{act.time}</p>
             </div>
          </div>
        ))}
      </div>
    </div>
  );
}
